define('formkit/view/form.object/rule/rule.target.modal.view',['require','exports','module','underscore','uikit/uikit','../../../form.object.util'],function(require, exports, module) {
  //prettier-ignore
  var _              = require('underscore'),
      UIKit          = require('uikit/uikit'),
      FormObjectUtil = require('../../../form.object.util');

  var TreeState = Mn.Object.extend({
    options: {
      minColumnHeaderCount: 3,
    },

    initialize: function() {
      Mn.Object.prototype.initialize.apply(this, arguments);

      this.mergeOptions(this.options, ['rootCollection', 'checkedModel']);

      this.selectedCollection = new Backbone.Collection();
      this.columnHeaderCollection = new Backbone.Collection([
        { text: 'Section' },
        { text: 'Questions' },
        { text: 'Options' },
      ]);

      var parent = this.checkedModel;
      if (parent) {
        var originalParentIndex = 0;

        while (!this.rootCollection.contains(parent)) {
          this.selectedCollection.unshift(parent);
          parent = FormObjectUtil.parent(parent);
          originalParentIndex++;
        }

        if (parent) {
          this.selectedCollection.unshift(parent);
          originalParentIndex++;

          while (this.columnHeaderCollection.length < originalParentIndex + 1) {
            this.columnHeaderCollection.add({ text: 'Sub-options' });
          }
        }
      }
    },

    getCollectionAtColumnIndex: function(columnIndex) {
      if (columnIndex === 0) {
        return this.getRootCollection();
      } else {
        if (this.selectedCollection.at(columnIndex - 1)) {
          return this.selectedCollection.at(columnIndex - 1).get('children');
        } else {
          return null;
        }
      }
    },

    setSelectedModelAtColumnIndex: function(model, columnIndex) {
      var selectedModel = null;
      while ((selectedModel = this.selectedCollection.at(columnIndex))) {
        this.selectedCollection.remove(selectedModel);
      }

      if (columnIndex >= this.columnHeaderCollection.length - 1) {
        this.columnHeaderCollection.add({ text: 'Sub-options' });
      } else {
        var columnHeaderModel = null;
        var furthestHeaderIndex = Math.max(columnIndex + 2, this.getOption('minColumnHeaderCount'));

        while ((columnHeaderModel = this.columnHeaderCollection.at(furthestHeaderIndex))) {
          this.columnHeaderCollection.remove(columnHeaderModel);
        }
      }

      this.selectedCollection.add(model, { at: columnIndex });

      this.triggerMethod('change:selectedModel');
      this.triggerMethod('change:selectedCollection');
    },

    getSelectedModelAtColumnIndex: function(columnIndex) {
      return this.selectedCollection.at(columnIndex);
    },

    getLastSelectedModel: function() {
      return this.selectedCollection.last();
    },

    setCheckedModel: function(model) {
      this.checkedModel = model;

      this.triggerMethod('change:checkedModel');
    },

    getCheckedModel: function() {
      return this.checkedModel;
    },

    setRootCollection: function(rootCollection) {
      this.rootCollection = rootCollection;

      this.triggerMethod('change:rootCollection');
    },

    getRootCollection: function() {
      return this.rootCollection;
    },

    getColumnHeaderCollection: function() {
      return this.columnHeaderCollection;
    },
  });

  var RuleTargetItemView = UIKit.ItemView.extend({
    className: 'item',

    template: function() {
      return '<ui name="checkboxView" /> <ui name="textView" /> <ui name="chevronView" />';
    },

    options: {
      currentIndex: -1,
      selected: false,
      disabled: false,
      checked: false,
      lastSelected: false,
    },

    triggers: {
      click: {
        event: 'press',
        preventDefault: false,
        stopPropagation: false,
      },
    },

    internalViewBindings: {
      checkboxView: {
        value: 'checked',
        disabled: 'disabled',
      },
    },

    internalViewOptions: {
      checkboxView: function() {
        return {
          type: UIKit.Checkbox.extend({
            triggers: {
              click: {
                event: 'press',
                preventDefault: false,
                stopPropagation: true,
              },
            },
          }),
          visible: this.form.isTemplateObjectTargetable(this.model),
        };
      },
      textView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'text',
          },
          form: this.form,
        };
      },
      chevronView: function() {
        return {
          type: UIKit.Button,
          icon: 'chevron right',
          inline: true,
          basic: true,
          floated: 'right',
          model: this.model,
          visible: this.form.util.hasChildren(this.model),
        };
      },
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.listenTo(this.treeState, 'change:selectedModel', function() {
        this.updateSelectedOption();
        this.updateLastSelectedOption();
      });

      this.listenTo(this.treeState, 'change:checkedModel', function() {
        this.updateCheckedAndDisabledOptions();
      });

      this.listenTo(this.checkboxView, 'change:value', function(view) {
        if (this.checkboxView.value) {
          this.treeState.setCheckedModel(this.model);
        } else {
          this.treeState.setCheckedModel(null);
        }

        this.treeState.setSelectedModelAtColumnIndex(this.model, this.currentIndex);
      });

      this.updateSelectedOption();
      this.updateLastSelectedOption();
      this.updateCheckedAndDisabledOptions();
    },

    onPress: function() {
      this.treeState.setSelectedModelAtColumnIndex(this.model, this.currentIndex);
    },

    updateAttributes: function() {
      this.addClass('disabled', this.getOption('disabled'));
      this.addClass('active', this.getOption('selected'));
      this.addClass('last-selected', this.getOption('lastSelected'));
    },

    updateSelectedOption: function() {
      if (this.treeState.getSelectedModelAtColumnIndex(this.currentIndex) === this.model) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    },

    updateLastSelectedOption: function() {
      if (this.treeState.getLastSelectedModel() === this.model) {
        this.lastSelected = true;
      } else {
        this.lastSelected = false;
      }
    },

    updateCheckedAndDisabledOptions: function() {
      if (this.treeState.getCheckedModel() === this.model) {
        this.checked = true;
      } else if (this.isDisabledTemplateObjectType()) {
        this.disabled = true;
      } else if (this.treeState.getCheckedModel()) {
        this.checked = false;
        this.disabled = true;
      } else {
        this.checked = false;
        this.disabled = false;
      }
    },

    isDisabledTemplateObjectType: function() {
      if (_.isUndefined(this.templateObjectTypeConfig)) {
        return false;
      }
      if (
        _.has(this.templateObjectTypeConfig, 'enabled') &&
        _.isArray(this.templateObjectTypeConfig.enabled) &&
        this.templateObjectTypeConfig.enabled.includes(this.model.get('type').id)
      ) {
        return false;
      }
      if (_.has(this.templateObjectTypeConfig, 'disableOthers') && this.templateObjectTypeConfig.disableOthers) {
        return true;
      }
      return false;
    },
  });

  var RuleTargetApplyToAllView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="textView" />';
    },
    className: 'apply-to-all-container',

    options: {
      text: '',
    },

    internalViewBindings: {
      textView: {
        text: 'text',
      },
    },

    internalViewOptions: {
      textView: function() {
        return {
          type: UIKit.Text,
          text: this.getOption('text'),
        };
      },
    },
  });

  var RuleTargetCompositeView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="columnHeaderView" /> <ui name="listView" /> <ui name="textView" />';
    },

    className: 'tree column',

    options: {
      columnBodyText: '',
      columnHeaderText: '',
      collection: null,
    },

    bindings: {
      columnHeaderText: 'text',
    },

    internalViewBindings: {
      columnHeaderView: {
        text: 'columnHeaderText',
      },
      listView: {
        collection: 'collection',
      },
      textView: {
        text: 'columnBodyText',
      },
    },

    internalViewOptions: {
      columnHeaderView: function() {
        return {
          type: UIKit.Header,
          tagName: 'h5',
        };
      },
      listView: function() {
        var self = this;
        return {
          type: UIKit.CollectionView.extend({
            className: 'ui selection divided tree list',

            childView: RuleTargetItemView,
            childViewOptions: function() {
              return {
                form: self.form,
                treeState: self.treeState,
                currentIndex: self.currentIndex,
                templateObjectTypeConfig: self.templateObjectTypeConfig,
              };
            },
          }),
        };
      },
      textView: function() {
        return {
          type: RuleTargetApplyToAllView,
          visible: false,
        };
      },
    },

    initialize: function() {
      UIKit.CompositeView.prototype.initialize.apply(this, arguments);

      this.listenTo(this.treeState, 'change:selectedCollection', function() {
        this.collection = this.treeState.getCollectionAtColumnIndex(this.currentIndex);
      });

      this.listenTo(this.treeState, 'change:checkedModel change:selectedCollection', function() {
        this.updateColumnBodyVisibilty();
        this.updateColumnBodyText();
      });

      this.collection = this.treeState.getCollectionAtColumnIndex(this.currentIndex);
      this.updateColumnBodyVisibilty();
      this.updateColumnBodyText();
    },

    updateColumnBodyVisibilty: function() {
      if (this.isDefinedAndEmpty() || this.isCheckedModelsChildren()) {
        this.listView.visible = false;
        this.textView.visible = true;
      } else {
        this.listView.visible = true;
        this.textView.visible = false;
      }
    },

    updateColumnBodyText: function() {
      if (this.isDefinedAndEmpty()) {
        if (this.currentIndex > 1) {
          this.columnBodyText = 'No options apply to this question.';
        } else {
          this.columnBodyText = 'No questions apply to this section.';
        }
      } else {
        if (this.currentIndex > 1) {
          this.columnBodyText = 'The rule will apply to any of the options.';
        } else {
          this.columnBodyText = 'The rule will apply to any of the questions.';
        }
      }
    },

    isCheckedModelsChildren: function() {
      return this.treeState.getCheckedModel() && this.collection === this.treeState.getCheckedModel().get('children');
    },

    isDefinedAndEmpty: function() {
      return this.collection && this.collection.length === 0;
    },
  });

  var RuleTargetCollectionView = UIKit.CompositeView.extend({
    template: function() {
      return '<div class="ui tree container inner"></div>';
    },

    className: 'tree outer',

    ui: {
      innerContainer: '.ui.tree.container.inner',
    },

    childView: RuleTargetCompositeView,
    childViewContainer: '@ui.innerContainer',
    childViewOptions: function(model, index) {
      return {
        form: this.form,
        treeState: this.treeState,
        currentIndex: index,
        templateObjectTypeConfig: this.templateObjectTypeConfig,
      };
    },

    initialize: function() {
      UIKit.CompositeView.prototype.initialize.apply(this, arguments);

      this.collection = this.treeState.getColumnHeaderCollection();
    },

    onFirstRender: function() {
      this.listenTo(this.collection, 'update reset', function() {
        this.updateScrollPosition();
      });
    },

    updateScrollPosition: function() {
      var scrollPosition = this.children.reduce(function(currentWidth, childView) {
        return currentWidth + childView.$el.outerWidth();
      }, 0);

      this.ui.innerContainer.animate({ scrollLeft: scrollPosition }, 500);
    },
  });

  var RuleTargetModalView = UIKit.Modal.extend({
    options: _.extend({}, UIKit.Modal.prototype.options, {
      closable: true,
      closeIcon: false,
      size: '',
      disablePositionRefresh: true,
    }),

    internalViewOptions: {
      content: function() {
        return {
          type: RuleTargetCollectionView,
          form: this.form,
          treeState: new TreeState({
            rootCollection: this.form.getTemplateModel().get('children'),
            checkedModel: this.getOption('checkedModel'),
          }),
          templateObjectTypeConfig: this.getOption('templateObjectTypeConfig'),
        };
      },
    },

    initialize: function() {
      UIKit.Modal.prototype.initialize.apply(this, arguments);

      this.treeState = this.content.treeState;
      this.header.text = 'Add Rule';

      this.actions.addDeny(new UIKit.Button({ text: 'Cancel', color: '' }));
      this.actions.addApprove((this.saveButton = new UIKit.Button({ text: 'Save', color: 'primary' })));

      this.listenTo(this.treeState, 'change:checkedModel', function() {
        this.updateSaveButtonDisabledOption();
      });

      this.updateSaveButtonDisabledOption();
    },

    onModalVisible: function() {
      this.content.updateScrollPosition();
    },

    updateSaveButtonDisabledOption: function() {
      this.saveButton.disabled =
        !!this.treeState.getCheckedModel() && this.getOption('checkedModel') !== this.treeState.getCheckedModel()
          ? false
          : true;
    },

    onModalHidden: function() {
      this.destroy();
    },

    onApprove: function() {
      this.triggerMethod('templateObject:selected', this.treeState.getCheckedModel());
    },
  });

  RuleTargetModalView.TreeState = TreeState;
  RuleTargetModalView.RuleTargetItemView = RuleTargetItemView;
  RuleTargetModalView.RuleTargetApplyToAllView = RuleTargetApplyToAllView;
  RuleTargetModalView.RuleTargetCompositeView = RuleTargetCompositeView;
  RuleTargetModalView.RuleTargetCollectionView = RuleTargetCollectionView;

  module.exports = RuleTargetModalView;
});

